
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType, FeatureType,
} from '@appblocks/codegeneration/types';
import * as zephyr from './zephyr';
import * as simulator from './simulator';
import BaseGPIOPeripheral from '../_BaseGPIOPeripheral';

export default class LED extends BaseGPIOPeripheral {
    constructor() {
        super();
        this.id = 'led';
        this.name = 'LED';
        this.singleInstance = false;
        this.requirements = ['zephyr', 'gpio'];
        this.featureType = FeatureType.PERIPHERAL;

        // this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return zephyr.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/gpio_type';
    }
}
